<template>
  <div class="detail">
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c">
        <i class="iconfont icon-houtui"></i> 返回
      </div>
      <div class="headerTitle flex1 flex-box flex-hv-c">预警详情</div>
      <div class="flex1"></div>
    </header>
    <div class="detailsContent" v-cloak>
      <ul>
        <li>
          <div class="flex-box flex-v-c warning">
            <div class="flex1">
              <div>代理ID：
                <span>{{data.memberId}}</span>
              </div>
              <div>昵称：
                <span>{{data.nickname}}</span>
              </div>
            </div>
            <div class="flex1">
              <div>联系方式：
                <span>{{memberMobile}}</span>
                <span class="copy-btn" @click="copy">复制</span>     
              </div>
              <div>绑定人数：
                <span>{{data.bindCount}}</span>
              </div>
            </div>
          </div>
          <div style="padding-top:5px;">
            <div >
              <div>最后登录游戏：
                <span class="amColor">{{data.gameTime | formatDate}}</span>
              </div>
            </div>
            <div>
              <div>最后登录后台：
                <span class="amColor">{{data.lastLoginTime | formatDate}}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div
        id="timeChose"
        class="flex-box flex-h-c timeChose"
        style="text-align: center;margin: 4px 0 15px 0;height: 35px;line-height: 35px;padding: 0 5px;"
      >
        <div
          class="flex1"
          data-type="7"
          style="border-radius: 4px;border: 1px solid #ccc;"
          :class="{focus:focusNum==0}"
          @click="changView(0)"
        >近一周数据</div>
        <div
          class="flex1"
          data-type="15"
          style="border-radius: 4px;border: 1px solid #ccc;margin: 0 5px"
          :class="{focus:focusNum==1}"
          @click="changView(1)"
        >近15天数据</div>
        <div
          class="flex1"
          data-type="30"
          style="border-radius: 4px;border: 1px solid #ccc;"
          :class="{focus:focusNum==2}"
          @click="changView(2)"
        >近一月数据</div>
      </div>
      <div id="changCiBox" style="width: 100%;height: 350px;padding: 0 5px 0 5px;"></div>
      <div id="fanLiBox" style="width: 100%;height: 350px;padding: 0 5px 0 5px;"></div>
    </div>
  </div>
</template>
<!--javascript-->
<script>
import Clipboard from '../../../static/js/clipboard.min'
export default {
  props: ['memberId'],
  data: function () {
    return {
      memberMobile : '',
      data: {},
      focusNum: 0,
      result7_time: [],//近一周
      result7_directPlay: [],//场次
      result7_totalIncome: [],//奖励
      result15_time: [],//近15天
      result15_directPlay: [],//场次
      result15_totalIncome: [],//奖励
      result30_time: [],//近一月
      result30_directPlay: [],//场次
      result30_totalIncome: []//奖励
    }
  },
  filters : {
    mobileFormat(value){
      var val = value + "";
      return val.substring(0 ,3) + 'XXXX' + val.substr(7);
    }
  },
  methods: {
    copy(){ 
      var that = this
      var clipboard = new Clipboard('.copy-btn', {
        text: function () {
          return that.data.mobileNum;
        },
      });
      clipboard.on('success', function (e) {
        if (!that.$common.common.browser.versions.weixin) {
          that.$toast('复制成功')
        } else {
          that.$toast('复制成功')
        }
      });
      clipboard.on('error', function (e) {
        that.$toast('复制失败,请手动长按复制');
        that.memberMobile = that.data.mobileNum;
      });
    },
    getData() {
      var that = this
      that.$http.get('/member/memberRecentInfo', { params: { memberId: that.memberId } }).then((res) => {
        if (res.code == 0) {
          that.data = res.data;
          that.memberMobile = that.data.mobileNum.substring(0 ,3) + 'XXXX' + that.data.mobileNum.substr(7)
          for (let i = 0; i < res.data.result7.length; i++) {
            that.result7_time.push(res.data.result7[i].createDate.toString().substr(4, 2) + "." + res.data.result7[i].createDate.toString().substr(-2))
            that.result7_directPlay.push(res.data.result7[i].directPlay)
            that.result7_totalIncome.push(res.data.result7[i].totalIncome)
          }

          for (let i = 0; i < res.data.result15.length; i++) {
            that.result15_time.push(res.data.result15[i].createDate.toString().substr(4, 2) + "." + res.data.result15[i].createDate.toString().substr(-2))
            that.result15_directPlay.push(res.data.result15[i].directPlay)
            that.result15_totalIncome.push(res.data.result15[i].totalIncome)
          }

          for (let i = 0; i < res.data.result30.length; i++) {
            that.result30_time.push(res.data.result30[i].createDate.toString().substr(4, 2) + "." + res.data.result30[i].createDate.toString().substr(-2))
            that.result30_directPlay.push(res.data.result30[i].directPlay)
            that.result30_totalIncome.push(res.data.result30[i].totalIncome)
          }

          that.changCiChart(that.result7_time, that.result7_directPlay, "近一周")
          that.fanLiChart(that.result7_time, that.result7_totalIncome, "近一周")

        } else {
          that.$toast(res.message)
        }
      })
    },
    changView(type) {
      let that = this;
      that.focusNum = type
      if (type == 0) {
        that.changCiChart(that.result7_time, that.result7_directPlay, "近一周")
        that.fanLiChart(that.result7_time, that.result7_totalIncome, "近一周")
      } else if (type == 1) {
        that.changCiChart(that.result15_time, that.result15_directPlay, "近15天")
        that.fanLiChart(that.result15_time, that.result15_totalIncome, "近15天")
      } else if (type == 2) {
        that.changCiChart(that.result30_time, that.result30_directPlay, "近一月")
        that.fanLiChart(that.result30_time, that.result30_totalIncome, "近一月")
      }
    },
    back() {
      this.$emit('ctrDetails', false)
    },
    changCiChart: function (xData, yData, subtext) {
      var myChart = this.$echarts.init(document.getElementById("changCiBox"));
      var option = {
        title: {
          text: '场次',
          subtext: subtext
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            // dataZoom: {
            //     yAxisIndex: 'none'
            // },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        dataZoom: [
          { show: false, start: 0, end: 100 },
          { type: 'inside', start: 0, end: 10 },
          { show: false, yAxisIndex: 0, filterMode: 'empty', width: 10, height: '80%', showDataShadow: false, left: '93%' }
        ],
        grid: {//画布位置
          left: '2%',
          right: '20%',
          bottom: '10%',
          containLabel: true
        },
        series: [
          {
            name: '场次',
            type: 'line',
            data: yData,
            markPoint: {
              // data: [
              //     {type: 'max', name: '最大值'},
              //     {type: 'min', name: '最小值'}
              // ]
            },
            markLine: {
              data: [
                { type: 'average', name: '平均值' }
              ]
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    fanLiChart: function (xData, yData, subtext) {

      var myChart = this.$echarts.init(document.getElementById("fanLiBox"));
      var option = {
        title: {
          text: '奖励',
          subtext: subtext
        },
        tooltip: {
          trigger: 'axis'
        },

        toolbox: {
          show: true,
          feature: {
            // dataZoom: {
            //     yAxisIndex: 'none'
            // },
            dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            restore: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        dataZoom: [
          { show: false, start: 0, end: 100 },
          { type: 'inside', start: 0, end: 10 },
          { show: false, yAxisIndex: 0, filterMode: 'empty', width: 10, height: '80%', showDataShadow: false, left: '93%' }
        ],
        grid: {//画布位置
          left: '2%',
          right: '20%',
          bottom: '10%',
          containLabel: true
        },
        series: [
          {
            name: '奖励',
            type: 'line',
            data: yData,
            markPoint: {
              // data: [
              //     {type: 'max', name: '最大值'},
              //     {type: 'min', name: '最小值'}
              // ]
            },
            markLine: {
              data: [
                { type: 'average', name: '平均值' }
              ]
            }
          }
        ]
      };
      myChart.setOption(option);
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.copy-btn{
  padding-left:10px;
  color:orangered;
}
.detailsContent {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  height: calc(100vh - 1rem);
}
.detail {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
}

.focus {
  background: #3d435f;
  color: #fff;
}

ul {
  li {
    line-height: 1.5;
    padding: 10px;
    position: relative;
    min-height: 1.2rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/memberWarn/detail.vue